import type { ValueFormatterParams } from 'ag-grid-community'

export function addCommasToNumber(value: number | string | null | undefined, decimals = 2): string {
  if (value === undefined || value === null) return '0.00'

  try {
    const numValue = typeof value === 'number' ? value : parseFloat(String(value))
    if (isNaN(numValue)) return '0.00'

    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })
  } catch (e) {
    console.error('Error formatting numeric value:', value, e)
    return '0.00'
  }
}

// formatCurrency and currencyFormatter have been moved to shared/formatters.ts
// Import from there instead: import { formatCurrency, currencyFormatter } from "@/components/SupplierReconciliation/shared/formatters";
